const i18n = require('i18n');

cc.Class({
    extends: cc.Component,

    properties: {
        labels: [cc.Label]
    },

    setPaytableInfo (paytableArray, coefficient) {
        this.labels.forEach((label, index) => {
            const container = label.node.parent;
            if (index >= paytableArray.length) {
                container.active = false;
            } else if (paytableArray[index] > 0) {
                container.active = true;
                label.string = i18n.formatCurrency(paytableArray[index] * coefficient);
            } else {
                container.active = false;
            }
        })
    },
});
